<template>
  <div class="moment-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="goBack" class="nav-wrap">
        <template>
          <!-- <span 
            v-for="(item, index) in monTypes" 
            :class="['zuxie-btn', {'zuxie-btn-nobg' : monTypes.indexOf(activeType) !== index && monTypes.length > 0} ]"
            :key="item.val"
            @click="switchMon(item)"
          >{{item.text}}</span> -->
          <span 
            v-for="(item, index) in monTypes" 
            :class="['mont-type', {'active' : monTypes.indexOf(activeType) === index && monTypes.length > 1} ]"
            :key="item.val"
            @click="switchMon(item)"
          >{{item.text}}</span>
        </template>
        <div class="nav-right" slot="right" v-if="['organ','teacher', 'student'].indexOf(role) !== -1">
          <span class="zuxie-btn batch-btn" @click="ifBatchDiaShow = true;">批量上传</span>
          <span class="zuxie-btn upload-btn" @click="ifUpdateDiaShow = true;">上传照片</span>
        </div>
      </yioks-page-nav>
      <!-- <component :is="comp" :class-id='classId' :list='montList' :ajax-end='ajaxEnd' @getList='getListHandle'></component> -->
      <moment-list :class-id='classId' :class-name="class_name" :list='montList' :ajax-end='ajaxEnd' @getList='getListHandle'></moment-list>
    </div>
    <el-dialog
      @close="batchDiaClose"
      :visible.sync="ifBatchDiaShow"
      :close-on-click-modal="false"
      top="8vh"
      width="680px"
      class="batch-dialog scroll-dialog yi-dialog-root"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title">批量上传</span>
        <span class="prompt">支持jpg,jpeg,png,gif格式的图片</span>
      </div>
      <div class="dialog-content">
        <vue-scroll :ops="disScrollOpt">
          <div class="dia-scroll-content">
            <picture-card ref="pictureCard" :url-list.sync="imageUrlList"></picture-card>
          </div>
        </vue-scroll>
      </div>
      <div class="footer-btn" slot="footer">
        <el-button type="primary" :loading='isBatchUpRepeat' @click="batchUpImgHandle">开始上传</el-button>
        <el-button type="danger" @click="ifBatchDiaShow = false">取消上传</el-button>
        
      </div>
    </el-dialog>
    <el-dialog
      @close="updateDiaClose"
      :visible.sync="ifUpdateDiaShow"
      :close-on-click-modal="false"
      top="8vh"
      width="450px"
      class="update-dialog yi-dialog-root"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title">上传照片</span>
        <!-- <span class="prompt">支持jpg,jpeg,png,gif格式的图片</span> -->
      </div>
      <div class="dialog-content">
        <up-image ref="updatePic"
                  :lt-size="{msg: '上传图片大小不能超过15MB!',reg: 15}"
                  :imgval.sync="upPicVal"
                  :showPreview="false"></up-image>
        <p class="up-tip">支持jpg,jpeg,png,gif格式的图片</p>
      </div>
      <div class="footer-btn" slot="footer">
        <el-button type="primary" :loading='isUpRepeat' @click="updateDiaCertain">确定</el-button>
        <el-button type="danger" @click="ifUpdateDiaShow = false;">取消</el-button>
        
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Icon from "vue-awesome/components/Icon";
import createScrollOpt from "@/assets/js/vuescrollOption";
import { batchUpImage, getMomentList } from "@/api/common/api";
import { correctStatus } from "@/assets/js/apiStatus";
import {storageData} from "@/assets/js/storage";

const HOSTURL = process.env.VUE_APP_URL;

export default {
  name: "Moment",
  props: {
    classId: [String, Number],
    monTypes: {
      type: Array,
      required: true,
    },
  },
  created() {
    this.getMomentList(this.activeType.ajaxParam);
  },
  data() {
    return {
      isUpRepeat: false,
      isBatchUpRepeat: false,
      activeType: this.monTypes[0],
      ifBatchDiaShow: false,
      ifUpdateDiaShow: false,
      ajaxEnd: false,
      montList: [],
      class_name:"",
      imageUrlList: [],
      upPicVal: "",
      role: (storageData.getUserInfo() || {}).member_type,
      disScrollOpt: createScrollOpt(true)
    };
  },
  methods: {
    getListHandle() {
      this.getMomentList(this.activeType.ajaxParam)
    },
    // momentType 表示要加载的是精彩瞬间还是我的瞬间
    getMomentList(momentType = '') {
      this.ajaxEnd = false;
      getMomentList({
        c_id: this.classId,
        type: momentType,
      }).then(({ data }) => {
        this.ajaxEnd = true;
        if (data.status === correctStatus) {
          this.montList = data.result.moment_list.map(item => ({
            ...item,
            picture_address: `${HOSTURL}${item.picture_address}`,
            is_cover: !!item.is_cover
          }));
          this.class_name = data.class_name;
        }
      });
    },
    batchUpImgHandle() {
      if(this.isBatchUpRepeat){return;}
      this.isBatchUpRepeat = true;
      const momType = this.activeType.ajaxParam;
      batchUpImage({
        c_id: this.classId,
        image_url: this.imageUrlList.map(item => item.url).join(",")
      }).then(({ data }) => {
        if (data.status === correctStatus) {
          this.getMomentList(momType);
        } else {
          this.$message.error(`上传失败，${data.msg}`);
        }
        this.ifBatchDiaShow = false;
        this.isBatchUpRepeat = false;
      }).catch(err => {
        this.isBatchUpRepeat = false;
        console.error(err);
      })
    },
    updateDiaCertain() {
      if(this.isUpRepeat){return;}
      this.isUpRepeat = true;
      if(!this.upPicVal) {
        this.$message.error("上传失败，图片不能为空");
        this.isUpRepeat = false;
        return;
      }
      const momType = this.activeType.ajaxParam;
      batchUpImage({
        c_id: this.classId,
        image_url: this.upPicVal
      }).then(({ data }) => {
        if (data.status === correctStatus) {
          this.getMomentList(momType);
        } else {
          this.$message.error(`上传失败，${data.msg}`);
        }
        this.ifUpdateDiaShow = false;
        this.isUpRepeat = false;
        // console.log(2)
      }).catch(err => {
        this.isUpRepeat = false;
        console.error(err);
      })
    },
    batchDiaClose() {
      this.imageUrlList = []
      this.$refs["pictureCard"].resetList();
    },
    updateDiaClose() {
      // console.log(1)
      this.$refs["updatePic"].delCoverImg();
    },
    switchMon(item) {
      if(item.val === this.activeType.val) return;
      this.activeType = item;
      const momType = this.activeType.ajaxParam
      if(this.monTypes.length <= 1) return;
      this.getMomentList(momType);
    },
    goBack() {
      this.$emit('back')
    }
  },
  computed: {
    // comp() {
    //   // '@/'必须写到这里，如果把 '@/' 直接写在属性 momentComponent.componentPath 中则会报错
    //   return () => import('@/'+this.activeType.componentPath)
    // }
  },
  components: {
    "v-icon": Icon,
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "picture-card": () => import("@/components/PictureCard/PictureCard"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "up-image": () => import("@/components/UpImage/UpImage"),
    "moment-list": () => import('@/components/Moment/MomentList/MomentList'),
  },
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/linDialog'

.moment-root
  zuxie-page-root()
  .main-content-wrap
    color $color_white
    font-size $font_size_medium
    .nav-wrap
      margin-bottom 25px 
      .mont-type 
        padding 5px 10px
        cursor pointer 
        font-size 18px
        &+.mont-type 
          margin-left 10px 
        &.active 
          color $color_suc 
      .zuxie-btn 
        &+.zuxie-btn 
          margin-left 10px
  .batch-dialog
    .dialog-content
      height 510px
    .footer-btn
      .btns
        display: flex
        justify-content: center
        color: $color_white
        .btn
          padding: 10px 25px
          margin: 0 10px
          border-radius: 4px
          cursor: pointer
          user-select: none
        .save
          background-color: $color_suc
        .cancel
          background-color: $color_err
  .update-dialog
    .dialog-content
      display flex
      flex-direction column
      justify-content center
      align-items center
    .footer-btn
      .btns
        display: flex
        justify-content: center
        color: $color_white
        .btn
          padding: 10px 25px
          margin: 0 10px
          border-radius: 4px
          cursor: pointer
          user-select: none
        .save
          background-color: $color_suc
        .cancel
          background-color: $color_err
.v-svg
  display block
</style>
